export const goodToKnowData = [
  {
    title: "Economy Double Room",
    goodToKnow: [
      {
        description:
          "📍 This property is in a good location. Guests have rated it 4.3!",
      },
      {
        description:
          "🛁 We have a shared bathroom available for your convenience.",
      },
      {
        description:
          "📶 Free fast WiFi is available in all rooms and common areas!",
      },
      {
        description: "🛏 Enjoy a comfortable Queen-sized bed during your stay.",
      },
      {
        description:
          "📍 Conveniently located near popular attractions and amenities.",
      },
      {
        description:
          "🕒 Late-night self-check-in is available for your convenience.",
      },
      {
        description:
          "🍳 Enjoy a self-service continental breakfast with your stay.",
      },
      {
        description: "🚗 Free parking is available on-site for all guests.",
      },
      {
        description: "🚌 3-minute walk to the nearest bus stop.",
      },
      {
        description: "🚗 5-minute drive from the town center.",
      },
      {
        description: "🌌 A popular spot for Northern Lights viewing.",
      },
      {
        description: "🛏 Cozy and comfortable room for a relaxing stay.",
      },
      {
        description: "📺 Netflix TV available for your entertainment.",
      },
      {
        description: "🍽 Kitchen facilities available for your use.",
      },
      {
        description: "🧺 Bedding provided for a comfortable night's sleep.",
      },
      {
        description: "🏠 Located in a quiet and peaceful neighborhood.",
      },
    ],
  },
  {
    title: "Double/Twin Room",
    goodToKnow: [
      {
        description:
          "📶 Free fast WiFi is available in all rooms and common areas!",
      },
      {
        description: "🛏 Enjoy a comfortable King or Twin bed during your stay.",
      },
      {
        description:
          "📍 Conveniently located near popular attractions and amenities.",
      },
      {
        description:
          "🕒 Late-night self-check-in is available for your convenience.",
      },
      {
        description:
          "🍳 Enjoy a self-service continental breakfast with your stay.",
      },
      {
        description: "🚗 Free parking is available on-site for all guests.",
      },
      {
        description: "🚌 4-minute walk to the nearest bus stop.",
      },
      {
        description: "🚗 10-minute drive from the town center.",
      },
      {
        description: "✈️ 55-minute drive from the airport.",
      },
      {
        description: "🌌 A popular spot for Northern Lights viewing.",
      },
      {
        description: "🛏 Spacious room with plenty of natural light.",
      },
      {
        description: "📺 Netflix TV available for your entertainment.",
      },
      {
        description: "🍽 Kitchen facilities available for your use.",
      },
      {
        description: "🧺 Bedding provided for a comfortable night's sleep.",
      },
      {
        description: "🏠 Located in a quiet and peaceful neighborhood.",
      },
      {
        description: "🛁 Shared bathroom with modern amenities.",
      },
    ],
  },
  {
    title: "Triple Room",
    goodToKnow: [
      {
        description:
          "📍 Conveniently located near popular attractions and amenities.",
      },
      {
        description:
          "🕒 Late-night self-check-in is available for your convenience.",
      },
      {
        description:
          "🍳 Enjoy a self-service continental breakfast with your stay.",
      },
      {
        description: "🚗 Free parking is available on-site for all guests.",
      },
      {
        description: "🚌 4-minute walk to the nearest bus stop.",
      },
      {
        description: "🚗 10-minute drive from the town center.",
      },
      {
        description: "✈️ 55-minute drive from the airport.",
      },
      {
        description: "🌌 A popular spot for Northern Lights viewing.",
      },
      {
        description:
          "📶 Free fast WiFi is available in all rooms and common areas!",
      },
      {
        description:
          "🛏 Enjoy a comfortable Queen or Twin bed during your stay.",
      },
      {
        description: "🛏 Spacious room with plenty of natural light.",
      },
      {
        description: "📺 Netflix TV available for your entertainment.",
      },
      {
        description: "🍽 Kitchen facilities available for your use.",
      },
      {
        description: "🧺 Bedding provided for a comfortable night's sleep.",
      },
      {
        description: "🏠 Located in a quiet and peaceful neighborhood.",
      },
      {
        description: "🛁 Shared bathroom with modern amenities.",
      },
    ],
  },
  {
    title: "Quadruple Room",
    goodToKnow: [
      {
        description:
          "🍳 Enjoy a self-service continental breakfast with your stay.",
      },
      {
        description: "🚗 Free parking is available on-site for all guests.",
      },
      {
        description: "🚌 4-minute walk to the nearest bus stop.",
      },
      {
        description: "🚗 10-minute drive from the town center.",
      },
      {
        description: "✈️ 55-minute drive from the airport.",
      },
      {
        description: "🌌 A popular spot for Northern Lights viewing.",
      },
      {
        description:
          "📶 Free fast WiFi is available in all rooms and common areas!",
      },
      {
        description: "🛏 Enjoy a comfortable King or Twin bed during your stay.",
      },
      {
        description:
          "📍 Conveniently located near popular attractions and amenities.",
      },
      {
        description:
          "🕒 Late-night self-check-in is available for your convenience.",
      },
      {
        description: "🛏 Spacious room with plenty of natural light.",
      },
      {
        description: "📺 Netflix TV available for your entertainment.",
      },
      {
        description: "🍽 Kitchen facilities available for your use.",
      },
      {
        description: "🧺 Bedding provided for a comfortable night's sleep.",
      },
      {
        description: "🏠 Located in a quiet and peaceful neighborhood.",
      },
      {
        description: "🛁 Shared bathroom with modern amenities.",
      },
    ],
  },
  {
    title: "Family Room",
    goodToKnow: [
      {
        description: "🌌 A popular spot for Northern Lights viewing.",
      },
      {
        description: "🛁 Enjoy a private bathroom exclusively for your family.",
      },
      {
        description:
          "📶 Free fast WiFi is available in all rooms and common areas!",
      },
      {
        description:
          "🛏 Enjoy a comfortable Queen bed and sofa bed during your stay.",
      },
      {
        description:
          "📍 Conveniently located near popular attractions and amenities.",
      },
      {
        description:
          "🕒 Late-night self-check-in is available for your convenience.",
      },
      {
        description:
          "🍳 Enjoy a self-service continental breakfast with your stay.",
      },
      {
        description: "🚗 Free parking is available on-site for all guests.",
      },
      {
        description: "🚌 4-minute walk to the nearest bus stop.",
      },
      {
        description: "🚗 10-minute drive from the town center.",
      },
      {
        description: "🛏 Spacious room with plenty of natural light.",
      },
      {
        description: "📺 Netflix TV available for your entertainment.",
      },
      {
        description: "🍽 Kitchen facilities available for your use.",
      },
      {
        description: "🧺 Bedding provided for a comfortable night's sleep.",
      },
      {
        description: "🏠 Located in a quiet and peaceful neighborhood.",
      },
      {
        description: "🛁 Private bathroom with modern amenities.",
      },
    ],
  },
  {
    title: "Two Bedroom Apartment",
    goodToKnow: [
      {
        description: "📶 Fast and reliable WiFi is included for all guests.",
      },
      {
        description:
          "🛏 Spacious bedrooms with comfortable beds for a relaxing stay.",
      },
      {
        description:
          "📍 Conveniently located near popular attractions and amenities.",
      },
      {
        description:
          "🕒 Late-night self-check-in is available for your convenience.",
      },
      {
        description:
          "🍳 Enjoy a self-service continental breakfast with your stay.",
      },
      {
        description: "🚗 Free parking is available on-site for all guests.",
      },
      {
        description: "🚌 4-minute walk to the nearest bus stop.",
      },
      {
        description: "🚗 10-minute drive from the town center.",
      },
      {
        description: "✈️ 55-minute drive from the airport.",
      },
      {
        description: "🌌 A popular spot for Northern Lights viewing.",
      },
      {
        description: "🛏 Spacious room with plenty of natural light.",
      },
      {
        description: "📺 Netflix TV available for your entertainment.",
      },
      {
        description: "🍽 Kitchen facilities available for your use.",
      },
      {
        description: "🧺 Bedding provided for a comfortable night's sleep.",
      },
      {
        description: "🏠 Located in a quiet and peaceful neighborhood.",
      },
      {
        description: "🛁 Private bathroom with modern amenities.",
      },
    ],
  },
  {
    title: "Three Bedroom Apartment",
    goodToKnow: [
      {
        description: "📍 Close to the city center and other key locations.",
      },
      {
        description:
          "🍳 Start your day with a delicious breakfast served daily.",
      },
      {
        description:
          "📶 Free fast WiFi is available in all rooms and common areas!",
      },
      {
        description: "🛏 Enjoy comfortable beds in spacious bedrooms.",
      },
      {
        description:
          "🕒 Late-night self-check-in is available for your convenience.",
      },
      {
        description: "🚗 Free parking is available on-site for all guests.",
      },
      {
        description: "🚌 4-minute walk to the nearest bus stop.",
      },
      {
        description: "🚗 10-minute drive from the town center.",
      },
      {
        description: "✈️ 55-minute drive from the airport.",
      },
      {
        description: "🌌 A popular spot for Northern Lights viewing.",
      },
      {
        description: "🛏 Spacious room with plenty of natural light.",
      },
      {
        description: "📺 Netflix TV available for your entertainment.",
      },
      {
        description: "🍽 Kitchen facilities available for your use.",
      },
      {
        description: "🧺 Bedding provided for a comfortable night's sleep.",
      },
      {
        description: "🏠 Located in a quiet and peaceful neighborhood.",
      },
      {
        description: "🛁 Private bathroom with modern amenities.",
      },
    ],
  },
];
